'use strict';

angular.module('imagetrend.components')
    .directive('hlpButtonGroup', [function () {
        return {
            restrict: 'AE',
            scope: {
                classes: '@?',
                loading: '=?'
            },
            transclude: true,
            replace: true,
            controller: ['$scope', function ($scope) {
                this.setLoader = function (loading, classes, text) {
                    $scope.groupLoading = loading;
                    $scope.buttonClass = classes;
                    $scope.loadingText = text;
                }
            }],
            templateUrl: 'templates/button-group/button-group.html',
            link: function (scope, elem, attrs, ctrl, transclude) {

                scope.groupLoading = false;

                scope.$on('$destroy', function () {
                    if (elem) {
                        angular.element(elem).off();
                        angular.element(elem).remove();
                        elem = null;
                    }
                });
            }
        };
    }])

;